import PropTypes from 'prop-types';
import React from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import {
  Dropdown,
  DropdownMenuDivider,
  DropdownMenuHeader,
  DropdownMenuItem
} from '@bibliocommons/deprecated-base-dropdown';
import * as Icons from '@bibliocommons/deprecated-base-icons';
import BCGoogleAnalyticsUtils from '@bibliocommons/utils-google-analytics';

import Context from '@bibliocommons/context';
import { SHELF_NAMES } from 'app/constants/ShelfConstants';

class OnShelfDropdown extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);
  }

  static getShelfOptions() {
    return Immutable.Map(SHELF_NAMES)
      .valueSeq()
      .toArray()
      .map(name => ({
        label: OnShelfDropdown.renderAddToShelfButtonContent(name),
        value: name
      }));
  }

  handleShelfMove(newShelfName) {
    const { currentShelfItem } = this.props;
    const shelf = currentShelfItem.get('shelf');
    const id = currentShelfItem.get('id');
    const metadataId = currentShelfItem.get('metadataId');
    const privateItem = currentShelfItem.get('privateItem');

    this.props.updateShelfItem(shelf, id, metadataId, { privateItem, newShelfName });

    BCGoogleAnalyticsUtils.event({
      eventCategory: 'NERF Search',
      eventAction: 'Move shelf item',
      eventLabel: shelf
    });
  }

  handleRemoveFromShelf() {
    const shelf = this.props.currentShelfItem.get('shelf');
    const id = this.props.currentShelfItem.get('id');
    const metadataId = this.props.currentShelfItem.get('metadataId');
    this.props.removeShelfItem(shelf, id, metadataId);
  }

  static renderAddToShelfButtonContent(name) {
    return (
      <span>
        <Icons.Books width={20} height={19} color="#666" />
        <FormattedMessage id={`label_shelf_${name}`} />
      </span>
    );
  }

  renderMovableShelfOptions() {
    const shelf = this.props.currentShelfItem.get('shelf');
    return OnShelfDropdown.getShelfOptions()
      .filter(option => option.value !== shelf)
      .map(option => {
        const handleShelfMove = e => {
          e.preventDefault();
          this.handleShelfMove(option.value);
        };

        return (
          <DropdownMenuItem key={`on-shelf-dropdown-header-move-${option.value}`}>
            <a href="#move-to-shelf" onClick={handleShelfMove}>
              {option.label}
            </a>
          </DropdownMenuItem>
        );
      });
  }

  renderOnShelfOptions() {
    const shelf = this.props.currentShelfItem.get('shelf');
    const header = (
      <DropdownMenuHeader key="on-shelf-dropdown-header">
        <FormattedHTMLMessage id="change_shelf_location" />
      </DropdownMenuHeader>
    );

    const handleRemoveFromShelf = e => {
      e.preventDefault();
      this.handleRemoveFromShelf();
    };

    const deleteOption = (
      <DropdownMenuItem key="on-shelf-dropdown-delete">
        <a href="#remove-from-shelf" className="shelf-delete" onClick={handleRemoveFromShelf}>
          <FormattedMessage id="button_remove_from_shelves" />
        </a>
      </DropdownMenuItem>
    );

    const deleteDivider = <DropdownMenuDivider key="on-shelf-dropdown-delete-divider" />;
    const goToShelfDivider = <DropdownMenuDivider key="on-shelf-dropdown-go-to-shelf-divider" />;

    const goToShelfOption = (
      <DropdownMenuItem key="on-shelf-dropdown-go-to-shelf">
        <a href={`/collection/show/my/library/${shelf}`} target="_parent">
          <FormattedMessage
            id="go_to_my_shelf"
            values={{
              shelf: <FormattedMessage id={`label_shelf_${shelf}`} />
            }}
          />
        </a>
      </DropdownMenuItem>
    );

    const goToShelfOptionBundle = this.context.mobileApp ? [] : [goToShelfDivider, goToShelfOption];

    return [header, this.renderMovableShelfOptions(), deleteDivider, deleteOption, ...goToShelfOptionBundle];
  }

  render() {
    const { currentShelfItem } = this.props;
    const shelf = currentShelfItem.get('shelf');

    return (
      <div className="cp-on-shelf-dropdown">
        <Dropdown
          dataKey="on-shelf-dropdown"
          className="btn-default btn-on-shelf"
          selected={OnShelfDropdown.renderAddToShelfButtonContent(shelf)}
        >
          {this.renderOnShelfOptions()}
        </Dropdown>
      </div>
    );
  }
}

OnShelfDropdown.propTypes = {
  currentShelfItem: ImmutablePropTypes.map,
  updateShelfItem: PropTypes.func.isRequired,
  removeShelfItem: PropTypes.func.isRequired
};

OnShelfDropdown.contextType = Context;

export default OnShelfDropdown;
